import CompScroll from "./CompScroll";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function MainSolution() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="solution">
        <div className="section-txt-wrap">
          {pc ? (
            <>
              <h2 className="section-title">
                <span className="basic-block">디지털트윈 시스템 구축을</span>
                <span className="basic-block">위한 통합 솔루션</span>
              </h2>

              <div className="section-content">
                <p>
                  DiTAP은 구축을 위한 통합 솔루션디지털 트윈 서비스 개발에
                  최적화된 기능 및 요구에 맞는 멀티플랫폼(WebGL, Unity) 솔루션을
                  제공합니다.
                </p>
              </div>
            </>
          ) : (
            <>
              <h2 className="section-title">
                <span className="basic-block">디지털트윈 시스템 </span>
                <span className="basic-block">구축을 위한 통합 솔루션</span>
              </h2>
              <div className="section-content">
                <p>DiTAP은 구축을 위한 통합 솔루션</p>
                <p>디지털 트윈 서비스 개발에 최적화된 기능 및 요</p>
                <p>구에 맞는 멀티플랫폼(WebGL, Unity) 솔루션을</p>
                <p>제공합니다.</p>
              </div>
            </>
          )}
          <Link className="link-fit" to="/ditap/overview">
            <button className="section-btn-wrap">
              <span className="section-btn-more">자세히 보기</span>
              <span className="section-btn"></span>
            </button>
          </Link>
        </div>
        {pc ? (
          <div>
            <ul className="solution-list">
              <li>
                <Link className="solution-item" to="ditap/ditapjs">
                  <div className="solution-txt-wrap">
                    <h3 className="solution-title">DiTAP JS</h3>
                    <div className="solution-content">
                      <p>
                        웹 기반 3차원 디지털 트윈 가시화를 통해 3차원 상에서
                        고도, 거리, 면적, 체적, 측정 기능을 제공합니다.
                      </p>
                    </div>
                  </div>
                  <p className="link-fit">
                    <button className="section-btn"></button>
                  </p>
                </Link>
              </li>
              <li>
                <Link className="solution-item" to="ditap/ditapforunity">
                  <div className="solution-txt-wrap">
                    <h3 className="solution-title">DiTAP for Unity</h3>
                    <div className="solution-content">
                      <p>
                        데스크탑 기반 디지털트윈 가시화를 위한 SDK와 3D 가시화
                        기능을 제공합니다.
                      </p>
                    </div>
                  </div>
                  <button className="section-btn"></button>
                </Link>
              </li>
              <li>
                <Link className="solution-item" to="ditap/ditapbuilder">
                  <div className="solution-txt-wrap">
                    <h3 className="solution-title">DiTAP Builder</h3>
                    <div className="solution-content">
                      <p>
                        3D Tiles, 3D Model, Point Cloud, 정사 영상, DEM 타입의
                        변환을 지원하고, 변환 이력 관리, 데이터 시각화 및
                        다운로드가 가능합니다.
                      </p>
                    </div>
                  </div>
                  <button className="section-btn"></button>
                </Link>
              </li>
            </ul>
          </div>
        ) : (
          <div>
            <div className="solution-list">
              <Swiper slidesPerView={"auto"} spaceBetween={40}>
                <SwiperSlide>
                  <Link to="ditap/ditapjs">
                    <div className="solution-item">
                      <div className="solution-txt-wrap">
                        <h3 className="solution-title">DiTAP JS</h3>
                        <div className="solution-content">
                          <p>
                            웹 기반에서 3차원 디지털트윈 가시화를 통해 3차원
                            상에서 고도, 거리, 면적, 체적 측정 기능을
                            제공합니다.
                          </p>
                        </div>
                      </div>
                      <button className="section-btn"></button>
                    </div>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link to="ditap/ditapforunity">
                    <div className="solution-item">
                      <div className="solution-txt-wrap">
                        <h3 className="solution-title">DiTAP for Unity</h3>
                        <div className="solution-content">
                          <p>
                            데스크탑 기반 디지털트윈 가시화를 위한 SDK와 3D
                            가시화 기능을 제공합니다.
                          </p>
                        </div>
                      </div>
                      <button className="section-btn"></button>
                    </div>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link to="ditap/ditapbuilder">
                    <div className="solution-item">
                      <div className="solution-txt-wrap">
                        <h3 className="solution-title">DiTAP Builder</h3>
                        <div className="solution-content">
                          <p>
                            3D Tiles, 3D Model, Point Cloud, 정사 영상, DEM
                            타입의 변환을 지원하고, 변환 이력 관리, 데이터
                            시각화 및 다운로드가 가능합니다.
                          </p>
                        </div>
                      </div>
                      <button className="section-btn"></button>
                    </div>
                  </Link>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        )}
      </div>
      <CompScroll value={3} />
    </>
  );
}

export default MainSolution;
